// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"958":"f55a6d7d3960e234","3128":"b3600fa5cf33c319","7263":"a4146acc8439aa19"}[chunkId] + ".js";
};